<template>
  <div :class="['rb-diamond-data-display', `rb-${mode}`]" v-if="diamondData">
    <div class="rb-dd-display-gia" v-if="gia">
      <gia-certificate
        :diamond="diamondData"
        :mode="editable ? 'num' : 'certified'"
      />
    </div>
    <div class="rb-dd-display-shape">Shape: {{ diamondData.shape }}</div>
    <div class="rb-dd-display-carat">
      Carat: {{ diamondData.size | carats }}
    </div>
    <div class="rb-dd-display-color">Color: {{ diamondData.color }}</div>
    <div class="rb-dd-display-clarity">Clarity: {{ diamondData.clarity }}</div>
    <div class="rb-dd-display-actions" v-if="editable">
      <button
        aria-label="Edit Diamond Data"
        @click.prevent="notifyEdit"
        id="btn-edit-diamond"
      >
        Edit
      </button>
    </div>
  </div>
</template>
<script>
/**
 * Displays diamond specific information: Shape, Carat, Color, Clarity
 *
 * @props
 * mode: String
 * editable: Boolean
 * gia: Boolean
 * diamond: Object
 *
 * @implements
 * CommMixin
 * FormattersMixin
 * TrackMixin
 *
 * @emits
 * rb-step-edit
 *
 * @listens
 * rb-selected-options-updated
 *
 */
import CommMixin from "@/mixins/CommMixin";
import TrackMixin from "@/mixins/TrackMixin";
import FormattersMixin from "@/mixins/FormattersMixin";
import GiaCertificate from "@/components/GiaCertificate";
export default {
  mixins: [CommMixin, FormattersMixin, TrackMixin],
  components: { GiaCertificate },
  props: {
    mode: {
      type: String,
      default: "static",
    },
    editable: {
      type: Boolean,
      default: false,
    },
    gia: {
      type: Boolean,
      default: false,
    },
    diamond: {
      type: Object,
    },
  },
  data: function () {
    return {
      diamondData: null,
    };
  },
  beforeMount: function () {
    if (this.mode === "subscriber") {
      this.subscribe(
        "rb-selected-options-updated",
        this.onSelectedOptionsUpdated
      );
    }
  },
  mounted: function () {
    if (this.mode === "static") {
      this.diamondData = this.diamond;
    }
  },
  methods: {
    onSelectedOptionsUpdated: function (data) {
      var selectedOptions = data.selectedOptions;
      var diamondData = selectedOptions.find(
        (selectedOption) => selectedOption.step.id === "diamond"
      );
      if (diamondData) {
        this.diamondData = diamondData.choice;
      }
    },
    notifyEdit: function (event) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
      this.broadcast("rb-step-edit", { id: "diamond", from: "widget" });
    },
  },
};
</script>
